import { useEffect, useState } from 'react';

const sections = [
  { id: 'hero', label: 'Accueil', href: '#hero' },
  { id: 'probleme', label: 'Le défi', href: '#probleme' },
  { id: 'solution', label: 'La solution', href: '#solution' },
  { id: 'clients', label: 'Pour qui ?', href: '#clients' },
  { id: 'briques', label: 'Les briques', href: '#briques' },
];

const NavigationSticky = () => {
  const [activeSection, setActiveSection] = useState<string>('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Afficher le menu après avoir scrollé au-delà du Hero
      const heroSection = document.getElementById('hero');
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        setIsVisible(window.scrollY > heroBottom - 100);
      }

      // Détecter la section active
      const scrollPosition = window.scrollY + 150; // Offset pour détecter avant d'arriver à la section

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id);
        if (section && scrollPosition >= section.offsetTop) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Appel initial

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const targetId = href.replace('#', '');
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const offsetTop = targetElement.offsetTop - 80; // Offset pour le menu sticky
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  };

  if (!isVisible) return null;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-200 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand */}
          <div className="flex-shrink-0">
            <a
              href="#hero"
              onClick={(e) => handleClick(e, '#hero')}
              className="text-xl font-bold text-primary-700 hover:text-primary-800 transition-colors"
            >
              Tunisie Parking
            </a>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-1">
            {sections
              .filter((section) => section.id !== 'hero') // Exclure Hero du menu
              .map((section) => (
                <a
                  key={section.id}
                  href={section.href}
                  onClick={(e) => handleClick(e, section.href)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    activeSection === section.id
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-600 hover:text-primary-700 hover:bg-gray-100'
                  }`}
                >
                  {section.label}
                </a>
              ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => {
                const menu = document.getElementById('mobile-menu');
                if (menu) {
                  menu.classList.toggle('hidden');
                }
              }}
              className="p-2 rounded-lg text-gray-600 hover:text-primary-700 hover:bg-gray-100"
              aria-label="Menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          id="mobile-menu"
          className="hidden md:hidden pb-4 border-t border-gray-200 mt-2"
        >
          <div className="flex flex-col space-y-1 pt-2">
            {sections
              .filter((section) => section.id !== 'hero')
              .map((section) => (
                <a
                  key={section.id}
                  href={section.href}
                  onClick={(e) => {
                    handleClick(e, section.href);
                    const menu = document.getElementById('mobile-menu');
                    if (menu) {
                      menu.classList.add('hidden');
                    }
                  }}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    activeSection === section.id
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-600 hover:text-primary-700 hover:bg-gray-100'
                  }`}
                >
                  {section.label}
                </a>
              ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationSticky;

